import type { TranslationKeys } from '../../../types';

export const INSURANCE_TYPE_OPTION_KEYS = [
  'insuranceAgentExperienceDetailsForm.options.typesInsurance.osago',
  'insuranceAgentExperienceDetailsForm.options.typesInsurance.kasko',
  'insuranceAgentExperienceDetailsForm.options.typesInsurance.mortgage',
  'insuranceAgentExperienceDetailsForm.options.typesInsurance.dms',
  'insuranceAgentExperienceDetailsForm.options.typesInsurance.lifeInsurance',
  'insuranceAgentExperienceDetailsForm.options.typesInsurance.corporateInsurance',
] as const satisfies readonly TranslationKeys[];

export const AVG_SALES_VOLUME_OPTION_KEYS = [
  'insuranceAgentExperienceDetailsForm.options.avgSalesVolume.upTo100000',
  'insuranceAgentExperienceDetailsForm.options.avgSalesVolume.from100000To500000',
  'insuranceAgentExperienceDetailsForm.options.avgSalesVolume.from500000To1000000',
  'insuranceAgentExperienceDetailsForm.options.avgSalesVolume.over1000000',
] as const satisfies readonly TranslationKeys[];

export const ACQUISITION_CHANNEL_OPTION_KEYS = [
  'insuranceAgentExperienceDetailsForm.options.acquisitionChannel.warmBase',
  'insuranceAgentExperienceDetailsForm.options.acquisitionChannel.aggregators',
  'insuranceAgentExperienceDetailsForm.options.acquisitionChannel.partnerNetwork',
  'insuranceAgentExperienceDetailsForm.options.acquisitionChannel.internet',
] as const satisfies readonly TranslationKeys[];

export const OWN_COOPERATION_REASON_KEY =
  'insuranceAgentExperienceDetailsForm.options.cooperationReason.own' as const satisfies TranslationKeys;

export const COOPERATION_REASON_OPTION_KEYS = [
  'insuranceAgentExperienceDetailsForm.options.cooperationReason.product',
  'insuranceAgentExperienceDetailsForm.options.cooperationReason.commission',
  'insuranceAgentExperienceDetailsForm.options.cooperationReason.partnerList',
  OWN_COOPERATION_REASON_KEY,
] as const satisfies readonly TranslationKeys[];

export const OWN_REASON_MAX_LENGTH = 300;
